import React from "react";
import { auth, db, storage } from "../../Firebase_Config/firebaseConfig";
import { deleteDoc, doc } from "firebase/firestore";
import { ref, deleteObject } from "firebase/storage";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import styles from "./BlogBody.module.css";

const BlogBody = ({ currentElement, authenticated }) => {
  const {
    author: { name = "Unknown", id: authorId } = {},
    title,
    postText,
    id,
    ImgSrc,
  } = currentElement;

  const deleteBlog = async (id, ImgSrc) => {
    try {
      if (ImgSrc) {
        const desertRef = ref(storage, ImgSrc);
        await deleteObject(desertRef);
      }
      const blogRef = doc(db, "blogPosts", id);
      await deleteDoc(blogRef);

      localStorage.setItem(
        "alertMsg",
        "Your Blog has been successfully deleted!"
      );
      localStorage.setItem("alertColor", "lightgreen");
      window.location.reload(false);
    } catch (error) {
      localStorage.setItem("alertMsg", error.message || error);
      localStorage.setItem("alertColor", "red");
    }
  };

  return (
    <>
      <Helmet>
        <title>Blogs | VALSCO</title>
        <meta
          name="description"
          content="Experience an interactive and effective blog-making experience with Valsco Technology's modern software solution."
        />
      </Helmet>

      <section className={styles.blogBodyCard}>
        <h4 className={styles.blogBodyCardTitle}>{title}</h4>

        <div className={styles.blogBodyContent}>
          <p className={styles.blogBodyCardDesc}>
            {postText && postText.length > 150
              ? `${postText.slice(0, 150)}...`
              : postText}
          </p>
          <p className={styles.blogBodyCardAuthor}>@{name}</p>
          {/* <p className={styles.blogBodyCardDate}>{formattedDate}</p> */}

          <div className={styles.blogBodyCardBtnDiv}>
            <Link to={`/BlogPage/${id}`} className={styles.blogBodyCardBtn}>
              Read Blog
            </Link>

            {authenticated && auth.currentUser?.uid === authorId && (
              <button
                className={styles.blogBodyCardBtn}
                onClick={() => deleteBlog(id, ImgSrc)}
              >
                Delete Blog
              </button>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogBody;
